import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import SqlImportModel from 'cio/models/sql-import';
import FeaturesService from 'ember-feature-flags/services/features';
import DS from 'ember-data';
import SqlImportDatabaseModel from 'cio/models/sql-import-database';
import RavenService from 'cio/services/raven';
import AlertsService from 'cio/services/alerts';

export default class SqlImport extends Route {
  @service features!: FeaturesService;
  @service store!: DS.Store;
  @service raven!: RavenService;
  @service alerts!: AlertsService;

  model(params: { sql_import_id: string }) {
    return this.store.findRecord('sql-import', params.sql_import_id);
  }

  redirect(model: SqlImportModel) {
    // Figure out the type and redirect to the correct nested route.
    let type = (model.belongsTo('database').value() as SqlImportDatabaseModel | null)?.type;

    if (type == null) {
      this.raven.withScope((scope) => {
        scope.setExtra('import_id', model.id);
        this.raven.captureException(new Error('SQLImport model is missing a database type'), scope);
      });

      this.alerts.error('sql-import.redirect.missing-type', 'Unknown database type for this SQL import');

      return;
    }

    return this.router.transitionTo('sql-imports.import', type, model.id);
  }
}
